import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { useRegisterNewUserInit } from '../../hooks/useInit'
import { Spinner } from '../Spinner'

export function NewUserSelectPlan() {
    const navigate = useNavigate()

    const { initComplete } = useRegisterNewUserInit()

    useEffect(() => {
        document.getElementById('root-spinner')?.remove()
    }, [])

    useEffect(() => {
        if (!initComplete) {
            return
        }

        navigate('/', { replace: true })
        window.location.href = '/'
    }, [initComplete, navigate])

    return (
        <div className="flex h-screen items-center justify-center">
            <Spinner />
        </div>
    )
}
